import { render, staticRenderFns } from "./CalcParcel.vue?vue&type=template&id=66667a2f"
import script from "./CalcParcel.vue?vue&type=script&lang=js"
export * from "./CalcParcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports